import type { PipelineNode } from '@/mocks/pipeline';

type Props = {
  selectedNode: PipelineNode | null;
  skill: { name: string; version: string; description: string } | null;
  onUpdateBody: (id: string, body: string) => void;
  locked?: boolean;
};

export default function SkillContentEditor({ selectedNode, skill, onUpdateBody, locked }: Props) {
  if (!selectedNode || !skill) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center text-center select-none">
        <i className="ri-code-s-slash-line text-texts text-4xl mb-3" />
        <div className="text-textp text-sm font-medium">Select a skill node to edit its content</div>
        <div className="text-texts text-xs mt-1">Pick a node in the Graph tab, then return here to edit its prompt body</div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="shrink-0 px-5 py-3 border-b border-border flex items-center gap-3">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-textp">{skill.name}</div>
          <div className="text-[11px] text-texts truncate">{skill.description}</div>
        </div>
        <span className="ml-auto shrink-0 text-[11px] font-mono px-1.5 py-0.5 rounded bg-surface border border-border text-texts">{skill.version}</span>
      </div>

      <div className="flex-1 overflow-hidden flex">
        <textarea
          value={selectedNode.body ?? ''}
          onChange={(e) => onUpdateBody(selectedNode.id, e.target.value)}
          spellCheck={false}
          readOnly={locked}
          className="flex-1 bg-surface/40 p-5 font-mono text-[13px] text-textp leading-relaxed outline-none resize-none placeholder:text-texts disabled:opacity-60"
          placeholder="Write the skill prompt body here..."
        />
      </div>

      <div className="shrink-0 px-5 py-2 border-t border-border text-[11px] text-texts flex items-center gap-2">
        <i className="ri-information-line" />
        Edits apply to this node only within this pipeline
      </div>
    </div>
  );
}